import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllItemDamageReasonsResponse, DamageReasonResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { DamageReasonAdapter } from './dto/item-damage-reason.adapter';
import { DamagereasonRequest } from './dto/item-damage-reason.request';
import { DamageReasonDto } from './dto/item-damage-reasons.dto';
import { DamageReason } from './item-damage-reason.entity';

@Injectable()
export class ItemDamageReasonsService {
    constructor(
        @InjectRepository(DamageReason) private damageReasonRepository: Repository<DamageReason>,
        private damageReasonAdapter: DamageReasonAdapter,
      ) { }

      async createItemDamageReason(damageReasondto:DamageReasonDto, isUpdate: boolean,request:Request): Promise<DamageReasonResponse> {
        try {
        
        if (!isUpdate) {
            const damageReasonEntity = await this.getDamageReason(damageReasondto.damageReason);
          if (damageReasonEntity) {
            throw new ErrorResponse(11104, 'Damage reason already exists');
          }
        }
        const convertedDamageReasonEntity: DamageReason = this.damageReasonAdapter.convertDtoToEntity(damageReasondto,isUpdate);
        const saveddamageReasonEntity: DamageReason = await this.damageReasonRepository.save(convertedDamageReasonEntity);
        const savedDamageReasonDto: DamageReasonDto = this.damageReasonAdapter.convertEntityToDto(saveddamageReasonEntity);
       
         if (savedDamageReasonDto) {
          const response = new DamageReasonResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Damage reason Updated Successfully':'Damage reason Created Successfully',savedDamageReasonDto);
          return response;
        } else {
          throw new ErrorResponse(11106,'Damage reason saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        throw error;
      }
    }

    /**
     * gets all  damage Reason details  
     * @returns all the damage Reason details .
     */
    // @LogActions({ isAsync: true })
    async getAllItemDamageReasons(): Promise<AllItemDamageReasonsResponse> {  
        try {
            const damageReasonDto: DamageReasonDto[] = [];
            // retrieves all plants
            const damageReasonEntities: DamageReason[] = await this.damageReasonRepository.find({
                order: { damageReason: "DESC" },
            });
            //   console.log(damageReasonEntities);
            if (damageReasonEntities.length>0) {
                damageReasonEntities.forEach(damageReasonEntity => {
                const convertedDamageReasonDto: DamageReasonDto = this.damageReasonAdapter.convertEntityToDto(damageReasonEntity);
                damageReasonDto.push(convertedDamageReasonDto);
                });
                const response = new AllItemDamageReasonsResponse(true, 11208, "Damage reasons retrieved successfully", damageReasonDto);
                return response;
            } else {
                //   console.log('yest')
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getDamageReason(damageReason: string): Promise<DamageReason> {
        //  console.log(employeeId);
            const response = await this.damageReasonRepository.findOne({
            where: {damageReason: damageReason},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value  damage Reason   
     * @param itemReq   damage Reason  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateItemdamageReason(damReq: DamagereasonRequest): Promise<DamageReasonResponse> {
        try {
            const damageReasonsExists = await this.getDamageReasonById(damReq.damageReasonId);
            if (damageReasonsExists) {
                if (damReq.versionFlag !== damageReasonsExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current damage reason information.Refresh and try again');
                } else {
                    
                        const damageReasonSatatus =  await this.damageReasonRepository.update(
                            { damageReasonId: damReq.damageReasonId },
                            { isActive: damReq.isActive,updatedUser: damReq.updatedUser });
                       
                        if (damageReasonsExists.isActive) {
                            if (damageReasonSatatus.affected) {
                                const damageReasonsResponse: DamageReasonResponse = new DamageReasonResponse(true, 10115, 'Damage reason is de-activated successfully');
                                return damageReasonsResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Damage reason is already deactivated');
                            }
                        } else {
                            if (damageReasonSatatus.affected) {
                                const damageReasonsResponse: DamageReasonResponse = new DamageReasonResponse(true, 10114, 'Damage reason is activated successfully');
                                return damageReasonsResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Damage reason is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getDamageReasonById(damageReasonId: number): Promise<DamageReason> {
    //  console.log(employeeId);
        const response = await this.damageReasonRepository.findOne({
        where: {damageReasonId: damageReasonId},
        });
        // console.log(employeeresponse);
        if (response) {
        return response;
        } else {
        return null;
        }
    }
}
